import Meta from '../../components/common/Meta';
import RedesignPageLayout from '../../components/common/RedesignPageLayout';
import AdminBlogRequests from '../../components/admin/AdminBlogRequests';

const meta = {
    title: '博客审核 - 管理页面 - 博客中心',
    keywords: '管理页面',
    description: '管理页面',
};

export default function AdminBlogRequestsPage() {
    return (
        <>
            <Meta meta={meta} />
            <RedesignPageLayout>
                <header className="redesign-page-header">
                    <h1 className="redesign-page-title">博客审核</h1>
                    <p className="redesign-page-desc">管理后台 — 审核用户提交的博客收录申请。</p>
                </header>
                <AdminBlogRequests />
            </RedesignPageLayout>
        </>
    );
}
